import {useAuthInfo, withRequiredAuthInfo} from "@propelauth/react";
import React, {useContext, useEffect, useState} from "react";
import {useForm} from "react-hook-form";

import {DeveloperProjectConfig, Discoverability} from "../../models/project";
import {DevBidFormConfig} from "./BidCustomDataConf";

import {Tabs, TabsContent, TabsList, TabsTrigger} from "../ui/tabs"
import {Card, CardHeader, CardContent, CardTitle} from "../ui/card";
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from "../ui/form";
import {ListofRounds_v2} from "./RoundConfigrator_v2";
import {Switch} from "../ui/switch";
import {fetchWithToken, putWithToken} from "../../api/apiBase";
import {useParams} from "react-router-dom";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import {ProjectContext} from "../../contexts/ProjectContext";
import {CompanyType} from "../../models/company";
import {ProjectBidInfo} from "../builder/ProjectBidInfo";
import {useToast} from "../../hooks/use-toast";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "../ui/tooltip";
import {InfoCircledIcon, TrashIcon} from "@radix-ui/react-icons";
import {Button} from "../ui/button";

type FormToggleFieldProps = {
    label: string;
    fname: string;
    form: any;
    description?: string;
    variant?: string;
    input_type?: string;
    place_holder?: string;
    disabled?: boolean;
    onChange?: (event: string) => void;
};


export function FormToggleField(
    {label, fname, variant, form, disabled, description}: FormToggleFieldProps) {
    return (
        <FormField
            control={form.control}
            name={fname}
            render={({field}) => (
                <FormItem>
                    <FormControl className="mr-2 my-2">
                        <Switch
                            disabled={disabled}
                            checked={field.value}
                            onCheckedChange={field.onChange}
                        />
                    </FormControl>
                    <FormLabel className="w-full">
                        {description ?

                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger>
                                            <span className="flex items-center gap-3">

                                                    {label}
                                                <InfoCircledIcon width={17} height={17}/>

                                            </span>
                                </TooltipTrigger>
                                <TooltipContent
                                    side={"right"}
                                >
                                    <p>{description}</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                            :<>{label}</>
                        }
                    </FormLabel>
                </FormItem>
            )}
        />
    );
}

function ProjectGlobals() {
    const projectContext = useContext(ProjectContext);
    const {accessToken} = useAuthInfo();
    const {project_id} = useParams();
    const {toast} = useToast()

    const form = useForm<DeveloperProjectConfig>(
        {
            defaultValues: {
                ve: {
                    enabled: true,
                    enable_sharing: true,
                    enable_public: false,
                    feedback_enabled: true,
                },
                discoverability: {
                    open_to_all: false,
                    previously_approved: false,
                    invite_only: true,
                },
                // marvin: true,
                scopes_enabled: false,
                smart_feedback: false,
            }
        }
    );

    useEffect(() => {
        fetchWithToken(`/projects/${project_id}/config`, accessToken as string)
            .then((data) => {
                console.log('loaded cfg', data);
                form.reset(data)

            }).catch((err) => {
            toast({
                title: "Error",
                description: "Failed to load Project Settings: " + JSON.stringify(error),
                variant: "destructive",
            })
        }).finally(

        )
    }, [project_id])

    const [toggleDisabled, setToggleDisabled] = useState(false)

    const isA = form.watch('discoverability.open_to_all');
    const isB = form.watch('discoverability.invite_only');
    const isC = form.watch('discoverability.previously_approved');

    useEffect(() => {
        if (isA ) {
          form.setValue('discoverability.invite_only', false);
          form.setValue('discoverability.previously_approved', false);
        }
    }, [isA, form.setValue])

    useEffect(() => {
        if (isB ) {
            form.setValue('discoverability.previously_approved', false);
          form.setValue('discoverability.open_to_all', false);
        }
    }, [isB, form.setValue])

    useEffect(() => {
        if (isC ) {
            form.setValue('discoverability.invite_only', false);
          form.setValue('discoverability.open_to_all', false);
        }
    }, [isC, form.setValue])


    const onSave = (data: DeveloperProjectConfig) => {
        console.log('Save:', data)
        if (accessToken) {
            putWithToken(`/projects/${project_id}/config`, JSON.stringify(data), accessToken)
                .then((data) => {

                }).catch((err) => {
                console.log(JSON.stringify(err))
                toast({
                    title: "Error",
                    description: "Failed to save: " + JSON.stringify(error),
                    variant: "destructive",
                })
            })
        }
    }

    if (projectContext?.role === CompanyType.builder) {
        return <div>You do not have permission to be here! </div>
    }

    return <div className={"container"}>
        <br/>
        <Card>
            <Form {...form} >
                <form onSubmit={(e) => {
                    form.handleSubmit(onSave)();
                }}>
                    <CardHeader>
                        <div className="flex columns-2 justify-between">
                            <CardTitle>Project Settings</CardTitle>
                            <Button
                                variant="outline"
                                type="submit"
                            >Save</Button>
                        </div>
                    </CardHeader>
                    <CardContent>

                        <div>
                            <strong className="space-y-2">Visibility</strong>
                            <FormToggleField
                                label={"Hidden - Invited Bidders Only "}
                                fname={"discoverability.invite_only"}
                                variant={"checkbox"} form={form}/>
                            <FormToggleField
                                label={"Visible to Previously Approved Bidders"}
                                fname={"discoverability.previously_approved"}
                                variant={"checkbox"}
                                description={"Including invited bidders"}
                                form={form}
                                />
                            <FormToggleField
                                label={"Fully Discoverable to Verified Bidders"}
                                fname={"discoverability.open_to_all"}
                                variant={"checkbox"}
                                form={form} />

                            {/*<FormToggleField*/}
                            {/*label={"Scopes are Enabled"}*/}
                            {/*fname={"smart_feedback"} variant={"checkbox"} form={form} disabled={true}/>*/}
                            <br/>
                        </div>
                        <strong className="space-y-4">Value Engineering (VE)</strong>
                        <FormToggleField
                            label={"Enable VE Module"}
                            fname={"ve.enabled"}
                            description={"VE is enabled"}
                            variant={"checkbox"}
                            form={form}/>
                        <FormToggleField
                            label={"Ranked Feedback"}
                            fname={"ve.feedback_enabled"}
                            description={"If multiple Bidders price a VE suggestion, they will see their rank on that price"}
                            variant={"checkbox"}
                            form={form}/>
                        <FormToggleField
                            label={"Share VE ideas with bidders"}
                            fname={"ve.enable_sharing"}
                            description={
                                "if Activited, you will be able to selectively share " +
                                "VE ideas to other bidders and get multiple prices"}
                            variant={"checkbox"}
                            form={form}/>
                        <FormToggleField
                            label={"All VE ideas are automatically shared"}
                            fname={"ve.enable_public"}
                            description={"If a Bidder suggests a VE idea, all other bidders will be able to see it."}
                            variant={"checkbox"}
                            form={form}/>
                        <br/>
                        <div className="space-y-4"><strong>Features</strong></div>
                        <FormToggleField
                            label={"Smart Feedback"}
                            fname={"smart_feedback"}
                            description={"Bidders will get AI generated feedback (coming soon)"}
                            variant={"checkbox"}
                            form={form}
                            disabled={true}/>
                        <FormToggleField
                            label={"Scopes are Enabled"}
                            fname={"scopes_enabled"}
                            variant={"checkbox"}
                            description={"Create multiple scopes per project (coming soon)"}
                            form={form}
                            disabled={true}/>

                    </CardContent>
                </form>
            </Form>
        </Card>
        <br/>
    </div>
}

/**
 *
 *
 * */
function ProjectConfig() {
    // Builders not allowed to view this
    const projectContext = useContext(ProjectContext);
    if (projectContext?.role === CompanyType.builder) {
        return <ProjectBidInfo/>
    }

    return <Tabs defaultValue="bid_rounds">
        <TabsList>
            <TabsTrigger value="bid_rounds">Rounds</TabsTrigger>
            <TabsTrigger value="bid_setup">Bid Template</TabsTrigger>
            <TabsTrigger value="visibility">Project</TabsTrigger>
        </TabsList>

        <TabsContent value="bid_rounds"> <ListofRounds_v2/></TabsContent>
        <TabsContent value="bid_setup"><DevBidFormConfig/></TabsContent>
        <TabsContent value="visibility"><ProjectGlobals/></TabsContent>
    </Tabs>
}


export default withRequiredAuthInfo(ProjectConfig);
